import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Play } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { Upcoming } from "./Upcoming";
import { scrollToId } from "./SmoothScroll";
import { videoThumb } from "../../data/site";

export const Music = ({ latest, upcoming }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const title = latest?.title || "Paper Crown";
  const [first, ...rest] = title.split(" ");
  return (
    <section id="music" ref={ref} data-testid="music-section" className="px-4 py-24 sm:px-8 sm:py-32 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow num="03">Music</Eyebrow>
          <h2 className="mt-6 font-display text-5xl uppercase leading-[0.9] sm:text-7xl">Out now <span className="font-serif-i normal-case text-[var(--cash)]">&amp; next up</span></h2>
        </Reveal>
        <div className="mt-14 grid gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <div data-testid="latest-release-card" className="relative h-full min-h-[480px] overflow-hidden rounded-[28px] border border-[var(--line)] [clip-path:polygon(0_0,100%_0,100%_90%,90%_100%,0_100%)]">
              <motion.img style={{ y, scale: 1.18 }} src={videoThumb(latest)} alt={title} className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(7,7,7,0.95)_10%,rgba(7,7,7,0.2)_60%)]" />
              <span className="absolute left-6 top-6 rounded-full border border-[var(--bone)] px-4 py-2 font-mono text-xs font-bold uppercase tracking-[0.2em]">Latest</span>
              <div className="absolute inset-x-6 bottom-6 sm:inset-x-8 sm:bottom-8">
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--cash)]">{latest?.artist || "Kashae The God"}</p>
                <h3 data-testid="release-title" className="mt-2 font-display text-6xl uppercase leading-[0.88] sm:text-8xl">{first}{rest.length > 0 && <><br /><span className="outline-text">{rest.join(" ")}</span></>}</h3>
                <button data-testid="release-watch-btn" onClick={() => scrollToId("videos")}
                  className="mt-6 flex items-center gap-3 rounded-full bg-[var(--bone)] px-6 py-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-[var(--ink)] transition-transform hover:scale-105">
                  <Play size={14} fill="currentColor" /> Watch the video
                </button>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.12} className="lg:col-span-5">
            <Upcoming upcoming={upcoming} />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
